import { gql } from '@apollo/client';

import { queryClient, useMutation } from '@fhs/client';
import { UserAccountsDocument } from '@fhs-legacy/frontend/src/generated/rbi-graphql';
import { client } from '@fhs-legacy/frontend/src/state/graphql/client';
import { useLocale } from '@fhs-legacy/frontend/src/state/intl';

const AddGiftCardMutation = gql`
  mutation AddGiftCard($input: AddGiftCardInput) @gateway @authRequired {
    addGiftCard(input: $input) {
      giftCardDetails {
        accountIdentifier
        cardType
        currentBalance
        last4
      }
      giftCardTransferDetails {
        newBalance
      }
    }
  }
`;

export function useAddGiftCardMutation() {
  const { feCountryCode } = useLocale();

  return useMutation({
    mutationFn: async (input: { cardNumber: string; pin: string }) => {
      // Using Apollo client abstraction for now, but the idea is to replace this once we define how to hit Gateway without using Apollo.
      const { data } = await client.mutate({
        mutation: AddGiftCardMutation,
        fetchPolicy: 'no-cache',
        variables: { input },
        refetchQueries: [{ query: UserAccountsDocument, variables: { feCountryCode } }], // We need to refetch UserAccounts when updating payment methods
      });

      return data?.addGiftCard;
    },
    onSuccess: () => {
      // Invalidate React Query cache to refresh UI with new gift card data
      queryClient.invalidateQueries({ queryKey: ['userAccounts'] });
      queryClient.invalidateQueries({ queryKey: ['digitalGiftCardBalance'] });
    },
  });
}
